import React, { useEffect, createElement } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { UpsellPage } from './pages/UpsellPage';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  useEffect(() => {
    // UTMify UTMs script
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-xcod-sck', '');
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    document.head.appendChild(utmifyScript);
    (window as any).pixelId = '69a84f432f2498111cab00d3';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // Google tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H6W0NPCL3K';
    document.head.appendChild(gtagScript);
    const gtagInline = document.createElement('script');
    gtagInline.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-H6W0NPCL3K');
    `;
    document.head.appendChild(gtagInline);
    // Meta Pixel Code
    const metaPixelScript = document.createElement('script');
    metaPixelScript.textContent = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1462172198895039');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(metaPixelScript);
    const metaPixelNoscript = document.createElement('noscript');
    metaPixelNoscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1462172198895039&ev=PageView&noscript=1" />';
    document.head.appendChild(metaPixelNoscript);
    return () => {
      document.head.removeChild(utmifyScript);
      document.head.removeChild(pixelScript);
      document.head.removeChild(gtagScript);
      document.head.removeChild(gtagInline);
      document.head.removeChild(metaPixelScript);
      document.head.removeChild(metaPixelNoscript);
    };
  }, []);
  return <HashRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />
        <Route path="/up1" element={<UpsellPage data-id="element-5" />} data-id="element-4" />
        <Route path="/thankyou1" element={<ThankYouPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </HashRouter>;
}